// Function that should never be called
// - Compile-time: produce an error if argument doesn't have type 'never'
// - Runtime: throw an exception
export function assertNever(value: never): never {
    throw new Error(`Unhandled discriminated union member: ${JSON.stringify(value)}`);
}
